import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-glow-top" />
    <div className="container">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/DTSLogo.png" alt="DTS Logo" className="flogo-img" />
            <div>
              <div className="flogo-name">Dynamic Tracking Solutions</div>
              <div className="flogo-sub">(Pvt.) Ltd.</div>
            </div>
          </div>
          <p className="footer-tagline">Pakistan's most trusted fleet management and vehicle tracking solution since 2019.</p>
          <div className="footer-socials">
            <a href="https://www.facebook.com/DynamicTrackingSolution/" target="_blank" rel="noreferrer" className="fsoc">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            </a>
            <a href="https://pk.linkedin.com/company/dynamic-tracking-solutions" target="_blank" rel="noreferrer" className="fsoc">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
            <a href="https://wa.me/923331128470" target="_blank" rel="noreferrer" className="fsoc">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4 className="fcol-title">Quick Links</h4>
          <ul className="fcol-links">
            {[
              ['Home', '/'],
              ['About Us', '/about-us'],
              ['Company Profile', '/company-profile'],
              ['CEO Message', '/ceo-message'],
              ['Why Us', '/why-us'],
              ['Gallery', '/gallery'],
              ['Packages', '/packages'],
              ['Our Team', '/our-team'],
              ['Contact Us', '/contact-us'],
              ['Privacy Policy', '/privacy-policy'],
            ].map(([label, href]) => (
              <li key={label}><a href={href} className="flink"><span className="flink-arrow">›</span>{label}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="fcol-title">Solutions</h4>
          <ul className="fcol-links">
            {['Real-Time Tracking','Fleet Management','Fuel Monitoring','Vehicle Maintenance','Temperature Control','Supply Chain','Video Monitoring','Waste Management'].map(solution => (
              <li key={solution}><a href="/solution" className="flink"><span className="flink-arrow">›</span>{solution}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="fcol-title">Contact</h4>
          <ul className="fcontacts">
            <li><span className="fcon-icon">📱</span><div><a href="https://wa.me/923331128470" className="fcon-link">0333-1128470</a><a href="https://wa.me/923302865313" className="fcon-link">0330-2865313</a></div></li>
            <li><span className="fcon-icon">📞</span><div><a href="tel:+9202134543541" className="fcon-link">(021) 34543541</a><a href="tel:+9202134543542" className="fcon-link">(021) 34543542</a></div></li>
            <li><span className="fcon-icon">✉️</span><div><a href="mailto:info@dtrackings.com" className="fcon-link">info@dtrackings.com</a><a href="mailto:supports@dtrackings.com" className="fcon-link">supports@dtrackings.com</a></div></li>
            <li><span className="fcon-icon">📍</span><div><span className="fcon-text">#202, 2nd Floor, Amber Estate, Block 7/8 PECHS, Karachi</span></div></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Dynamic Tracking Solutions (Pvt.) Ltd. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;